module.exports = __webpack_public_path__ + "media/images/facebook-5e1cb4b86ac3f872dadcbde3ed31cd4b.svg";